import { createFileRoute, redirect } from '@tanstack/react-router'

// A wrong link (missing the `grosir-` prefix) was shared on Instagram/WhatsApp
// in late June and sent 11 visits to a 404. Permanently redirect to the real LP.
export const Route = createFileRoute('/lp/manshet-sarung-tangan')({
  beforeLoad: () => {
    throw redirect({ href: '/lp/grosir-manshet-sarung-tangan', statusCode: 301 })
  },
})
